import React from "react";
import { CardClip } from "../../components/svgComponents";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import * as gameAction from "../../redux/game/action";
import { getPromptText } from "../../components/shared/utils";
class Prompt extends React.Component {
  componentDidMount() {
    this.props.setFlippedCard([]);
    this.props.setPlayerCards([]);
    console.log("ShikharShikharShikharShikhar")

  }

  render() {
    let flippedCards = [];

    const roomData = this.props.gameReducer.roomObj;
    let promptText = "";
    promptText = getPromptText(roomData);

    if (roomData) {
      if (roomData.game_state) {
        if (roomData.game_state.status === "Joining") {
          return <Redirect to={"/lobby"} />;
        }
        if (roomData.game_state.status === "Over") {
          return <Redirect to={"/final-result"} />;
        }
        if (roomData.game_state.status === "PrePlay") {
          return <Redirect to={"/game"} />;
        }

        if (
          roomData.game_state.played_cards &&
          roomData.game_state.played_cards.length > 0
        ) {
          let totalPlayedCards = roomData.game_state.played_cards;
          flippedCards = totalPlayedCards.filter(
            (card) => card.flipped === true
          );

          if (totalPlayedCards.length > 0) return <Redirect to={"/cards"} />;
        }
      }
    }

    let promptLabel = "Prompt";
    if (
      this.props.paramsReducer.gameObj &&
      this.props.paramsReducer.gameObj.screens
    ) {
      if (this.props.paramsReducer.gameObj.screens.gif.prompt_label) {
        promptLabel = this.props.paramsReducer.gameObj.screens.gif.prompt_label;
      }
    }

    return (
      <div className="prompt">
        <div className="wrapper">
          <p className="cartTip">
            <span className="wrapper">
              <span className="text">{promptLabel}</span>
              <CardClip />
            </span>
          </p>
          <div className="bg-theme br-16 contentWrapper">
            <div className="text-highlight content">
              <p className="promptText">{promptText}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  loaderDetails: state.loaderDetails,
  paramsReducer: state.paramsReducer,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setFlippedCard: (data) => dispatch(gameAction.setFlippedCard(data)),
    setPlayerCards: (data) => dispatch(gameAction.setPlayerCards(data)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Prompt);
